module.exports = __webpack_public_path__ + "img/i_wsp.e9376ba1.svg";